/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DockerWorkerConfigV3DockerCorruptnessCheck } from './DockerWorkerConfigV3DockerCorruptnessCheck';
import { DockerWorkerConfigV3DockerCorruptnessCheckFromJSON, DockerWorkerConfigV3DockerCorruptnessCheckFromJSONTyped, DockerWorkerConfigV3DockerCorruptnessCheckToJSON, } from './DockerWorkerConfigV3DockerCorruptnessCheck';
import type { DockerWorkerConfigV3DockerDatasource } from './DockerWorkerConfigV3DockerDatasource';
import { DockerWorkerConfigV3DockerDatasourceFromJSON, DockerWorkerConfigV3DockerDatasourceFromJSONTyped, DockerWorkerConfigV3DockerDatasourceToJSON, } from './DockerWorkerConfigV3DockerDatasource';
import type { DockerWorkerConfigV3DockerTraining } from './DockerWorkerConfigV3DockerTraining';
import { DockerWorkerConfigV3DockerTrainingFromJSON, DockerWorkerConfigV3DockerTrainingFromJSONTyped, DockerWorkerConfigV3DockerTrainingToJSON, } from './DockerWorkerConfigV3DockerTraining';
import type { DockerWorkerConfigV4DockerCrops } from './DockerWorkerConfigV4DockerCrops';
import { DockerWorkerConfigV4DockerCropsFromJSON, DockerWorkerConfigV4DockerCropsFromJSONTyped, DockerWorkerConfigV4DockerCropsToJSON, } from './DockerWorkerConfigV4DockerCrops';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * docker run configurations, keys should match the structure of
 * https://github.com/lightly-ai/lightly-core/blob/develop/onprem-docker/lightly_worker/src/lightly_worker/resources/docker/docker.yaml
 * @export
 * @interface DockerWorkerConfigV4Docker
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_DockerWorkerConfigV4Docker_checkpointRunId")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface DockerWorkerConfigV4Docker {
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    checkpoint?: string;
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof DockerWorkerConfigV4Docker
        
        
    * @pattern_DockerWorkerConfigV4Docker_checkpointRunId
         */
    checkpointRunId?: string;
    /**
     *
     * #type DockerWorkerConfigV3DockerCorruptnessCheck
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    corruptnessCheck?: DockerWorkerConfigV3DockerCorruptnessCheck;
    /**
     *
     * #type DockerWorkerConfigV3DockerDatasource
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    datasource?: DockerWorkerConfigV3DockerDatasource;
    /**
     *
     * #type DockerWorkerConfigV4DockerCrops
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    crops?: DockerWorkerConfigV4DockerCrops;
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    embeddings?: string;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    enableTraining?: boolean;
    /**
     *
     * #type DockerWorkerConfigV3DockerTraining
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    training?: DockerWorkerConfigV3DockerTraining;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    normalizeEmbeddings?: boolean;
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV4Docker
        * @type int
    * @minimum -1
            
         */
    numProcesses?: number;
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV4Docker
        * @type int
    * @minimum -1
            
         */
    numThreads?: number;
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    outputImageFormat?: string;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    pretagging?: boolean;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    pretaggingUpload?: boolean;
    /**
     *
     * #type string
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    relevantFilenamesFile?: string;
    /**
     *
     * #type number
     * #memberof DockerWorkerConfigV4Docker
        * @type int
    * @minimum 1
            
         */
    selectedSequenceLength?: number;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    uploadReport?: boolean;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    useDatapool?: boolean;
    /**
     *
     * #type boolean
     * #memberof DockerWorkerConfigV4Docker
        
        
         */
    shutdownWhenJobFinished?: boolean;
    /**
     * Maximum number of bytes stored in the disk cache. Setting it to <=0 disables the cache.
     * #type number
     * #memberof DockerWorkerConfigV4Docker
        * @type int
    * @minimum -1
            
         */
    cacheSize?: number;
}
/**
 * Check if a given object implements the DockerWorkerConfigV4Docker interface.
 */
export function instanceOfDockerWorkerConfigV4Docker(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DockerWorkerConfigV3DockerCorruptnessCheckValidator, DockerWorkerConfigV3DockerCorruptnessCheckStringifyShape, DockerWorkerConfigV3DockerCorruptnessCheckStringifyShapeProperties, } from './DockerWorkerConfigV3DockerCorruptnessCheck';
import { DockerWorkerConfigV3DockerDatasourceValidator, DockerWorkerConfigV3DockerDatasourceStringifyShape, DockerWorkerConfigV3DockerDatasourceStringifyShapeProperties, } from './DockerWorkerConfigV3DockerDatasource';
import { DockerWorkerConfigV3DockerTrainingValidator, DockerWorkerConfigV3DockerTrainingStringifyShape, DockerWorkerConfigV3DockerTrainingStringifyShapeProperties, } from './DockerWorkerConfigV3DockerTraining';
import { DockerWorkerConfigV4DockerCropsValidator, DockerWorkerConfigV4DockerCropsStringifyShape, DockerWorkerConfigV4DockerCropsStringifyShapeProperties, } from './DockerWorkerConfigV4DockerCrops';
export const DockerWorkerConfigV4DockerTypiaAssertEquals = (input: any) => {
    return ((input: any): DockerWorkerConfigV4Docker => {
        const __is = (input: any, _exceptionable: boolean = true): input is DockerWorkerConfigV4Docker => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io1(input.corruptnessCheck, true && _exceptionable)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io2(input.datasource, true && _exceptionable)) && (undefined === input.crops || "object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) && $io4(input.crops, true && _exceptionable)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io5(input.training, true && _exceptionable)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && Math.floor(input.cacheSize) === input.cacheSize && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647) && -1 <= input.cacheSize) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "crops", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "useDatapool", "shutdownWhenJobFinished", "cacheSize"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["corruptionThreshold"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io2 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io3(input.inputExpiration, true && _exceptionable)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bypassVerify", "enableDatapoolUpdate", "processAll", "inputExpiration"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io3 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.minDaysToExpiration && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy) && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["minDaysToExpiration", "handlingStrategy"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io4 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || Array.isArray(input.enableUploadForTasks) && input.enableUploadForTasks.every((elem: any, _index1: number) => "string" === typeof elem)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["enableUpload", "enableUploadForTasks"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io5 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName)) && (0 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["taskName"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV4Docker => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV4Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao1(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao2(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.crops || ("object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && $ao4(input.crops, _path + ".crops", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao5(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool || $guard(_exceptionable, {
                    path: _path + ".useDatapool",
                    expected: "(boolean | undefined)",
                    value: input.useDatapool
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                })) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && (Math.floor(input.cacheSize) === input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-1 <= input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@minimum -1)",
                    value: input.cacheSize
                })) || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "(number | undefined)",
                    value: input.cacheSize
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["checkpoint", "checkpointRunId", "corruptnessCheck", "datasource", "crops", "embeddings", "enableTraining", "training", "normalizeEmbeddings", "numProcesses", "numThreads", "outputImageFormat", "pretagging", "pretaggingUpload", "relevantFilenamesFile", "selectedSequenceLength", "uploadReport", "useDatapool", "shutdownWhenJobFinished", "cacheSize"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["corruptionThreshold"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (undefined === input.inputExpiration || ("object" === typeof input.inputExpiration && null !== input.inputExpiration || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && $ao3(input.inputExpiration, _path + ".inputExpiration", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bypassVerify", "enableDatapoolUpdate", "processAll", "inputExpiration"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.minDaysToExpiration && (0 <= input.minDaysToExpiration || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number (@minimum 0)",
                    value: input.minDaysToExpiration
                })) || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number",
                    value: input.minDaysToExpiration
                })) && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy || $guard(_exceptionable, {
                    path: _path + ".handlingStrategy",
                    expected: "(\"ABORT\" | \"SKIP\")",
                    value: input.handlingStrategy
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["minDaysToExpiration", "handlingStrategy"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload || $guard(_exceptionable, {
                    path: _path + ".enableUpload",
                    expected: "(boolean | undefined)",
                    value: input.enableUpload
                })) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || (Array.isArray(input.enableUploadForTasks) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                })) && input.enableUploadForTasks.every((elem: any, _index1: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks[" + _index1 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["enableUpload", "enableUploadForTasks"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV3DockerTraining_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                })) && (0 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["taskName"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV4Docker",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV4Docker",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DockerWorkerConfigV4DockerTypiaAssertStringify = (input: DockerWorkerConfigV4Docker): string => {
    return ((input: any): string => { const assert = (input: any): DockerWorkerConfigV4Docker => {
        const __is = (input: any): input is DockerWorkerConfigV4Docker => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && $is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId)) && (undefined === input.corruptnessCheck || "object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) && $io1(input.corruptnessCheck)) && (undefined === input.datasource || "object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) && $io2(input.datasource)) && (undefined === input.crops || "object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) && $io4(input.crops)) && (undefined === input.embeddings || "string" === typeof input.embeddings) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining) && (undefined === input.training || "object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) && $io5(input.training)) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && Math.floor(input.numProcesses) === input.numProcesses && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647) && -1 <= input.numProcesses) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && Math.floor(input.numThreads) === input.numThreads && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647) && -1 <= input.numThreads) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat) && (undefined === input.pretagging || "boolean" === typeof input.pretagging) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647) && 1 <= input.selectedSequenceLength) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && !Number.isNaN(input.cacheSize) && Math.floor(input.cacheSize) === input.cacheSize && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647) && -1 <= input.cacheSize);
            const $io1 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
            const $io2 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io3(input.inputExpiration));
            const $io3 = (input: any): boolean => "number" === typeof input.minDaysToExpiration && !Number.isNaN(input.minDaysToExpiration) && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy);
            const $io4 = (input: any): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || Array.isArray(input.enableUploadForTasks) && input.enableUploadForTasks.every((elem: any) => "string" === typeof elem));
            const $io5 = (input: any): boolean => undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName);
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DockerWorkerConfigV4Docker => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.checkpoint || "string" === typeof input.checkpoint || $guard(_exceptionable, {
                    path: _path + ".checkpoint",
                    expected: "(string | undefined)",
                    value: input.checkpoint
                })) && (undefined === input.checkpointRunId || "string" === typeof input.checkpointRunId && ($is_custom("pattern_DockerWorkerConfigV4Docker_checkpointRunId", "string", "", input.checkpointRunId) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "string (@pattern_DockerWorkerConfigV4Docker_checkpointRunId)",
                    value: input.checkpointRunId
                })) || $guard(_exceptionable, {
                    path: _path + ".checkpointRunId",
                    expected: "(string | undefined)",
                    value: input.checkpointRunId
                })) && (undefined === input.corruptnessCheck || ("object" === typeof input.corruptnessCheck && null !== input.corruptnessCheck && false === Array.isArray(input.corruptnessCheck) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && $ao1(input.corruptnessCheck, _path + ".corruptnessCheck", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".corruptnessCheck",
                    expected: "(DockerWorkerConfigV3DockerCorruptnessCheck | undefined)",
                    value: input.corruptnessCheck
                })) && (undefined === input.datasource || ("object" === typeof input.datasource && null !== input.datasource && false === Array.isArray(input.datasource) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && $ao2(input.datasource, _path + ".datasource", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".datasource",
                    expected: "(DockerWorkerConfigV3DockerDatasource | undefined)",
                    value: input.datasource
                })) && (undefined === input.crops || ("object" === typeof input.crops && null !== input.crops && false === Array.isArray(input.crops) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && $ao4(input.crops, _path + ".crops", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".crops",
                    expected: "(DockerWorkerConfigV4DockerCrops | undefined)",
                    value: input.crops
                })) && (undefined === input.embeddings || "string" === typeof input.embeddings || $guard(_exceptionable, {
                    path: _path + ".embeddings",
                    expected: "(string | undefined)",
                    value: input.embeddings
                })) && (undefined === input.enableTraining || "boolean" === typeof input.enableTraining || $guard(_exceptionable, {
                    path: _path + ".enableTraining",
                    expected: "(boolean | undefined)",
                    value: input.enableTraining
                })) && (undefined === input.training || ("object" === typeof input.training && null !== input.training && false === Array.isArray(input.training) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && $ao5(input.training, _path + ".training", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".training",
                    expected: "(DockerWorkerConfigV3DockerTraining | undefined)",
                    value: input.training
                })) && (undefined === input.normalizeEmbeddings || "boolean" === typeof input.normalizeEmbeddings || $guard(_exceptionable, {
                    path: _path + ".normalizeEmbeddings",
                    expected: "(boolean | undefined)",
                    value: input.normalizeEmbeddings
                })) && (undefined === input.numProcesses || "number" === typeof input.numProcesses && !Number.isNaN(input.numProcesses) && (Math.floor(input.numProcesses) === input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-2147483648 <= input.numProcesses && input.numProcesses <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@type int)",
                    value: input.numProcesses
                })) && (-1 <= input.numProcesses || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "number (@minimum -1)",
                    value: input.numProcesses
                })) || $guard(_exceptionable, {
                    path: _path + ".numProcesses",
                    expected: "(number | undefined)",
                    value: input.numProcesses
                })) && (undefined === input.numThreads || "number" === typeof input.numThreads && !Number.isNaN(input.numThreads) && (Math.floor(input.numThreads) === input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-2147483648 <= input.numThreads && input.numThreads <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@type int)",
                    value: input.numThreads
                })) && (-1 <= input.numThreads || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "number (@minimum -1)",
                    value: input.numThreads
                })) || $guard(_exceptionable, {
                    path: _path + ".numThreads",
                    expected: "(number | undefined)",
                    value: input.numThreads
                })) && (undefined === input.outputImageFormat || "string" === typeof input.outputImageFormat || $guard(_exceptionable, {
                    path: _path + ".outputImageFormat",
                    expected: "(string | undefined)",
                    value: input.outputImageFormat
                })) && (undefined === input.pretagging || "boolean" === typeof input.pretagging || $guard(_exceptionable, {
                    path: _path + ".pretagging",
                    expected: "(boolean | undefined)",
                    value: input.pretagging
                })) && (undefined === input.pretaggingUpload || "boolean" === typeof input.pretaggingUpload || $guard(_exceptionable, {
                    path: _path + ".pretaggingUpload",
                    expected: "(boolean | undefined)",
                    value: input.pretaggingUpload
                })) && (undefined === input.relevantFilenamesFile || "string" === typeof input.relevantFilenamesFile || $guard(_exceptionable, {
                    path: _path + ".relevantFilenamesFile",
                    expected: "(string | undefined)",
                    value: input.relevantFilenamesFile
                })) && (undefined === input.selectedSequenceLength || "number" === typeof input.selectedSequenceLength && !Number.isNaN(input.selectedSequenceLength) && (Math.floor(input.selectedSequenceLength) === input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (-2147483648 <= input.selectedSequenceLength && input.selectedSequenceLength <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@type int)",
                    value: input.selectedSequenceLength
                })) && (1 <= input.selectedSequenceLength || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "number (@minimum 1)",
                    value: input.selectedSequenceLength
                })) || $guard(_exceptionable, {
                    path: _path + ".selectedSequenceLength",
                    expected: "(number | undefined)",
                    value: input.selectedSequenceLength
                })) && (undefined === input.uploadReport || "boolean" === typeof input.uploadReport || $guard(_exceptionable, {
                    path: _path + ".uploadReport",
                    expected: "(boolean | undefined)",
                    value: input.uploadReport
                })) && (undefined === input.useDatapool || "boolean" === typeof input.useDatapool || $guard(_exceptionable, {
                    path: _path + ".useDatapool",
                    expected: "(boolean | undefined)",
                    value: input.useDatapool
                })) && (undefined === input.shutdownWhenJobFinished || "boolean" === typeof input.shutdownWhenJobFinished || $guard(_exceptionable, {
                    path: _path + ".shutdownWhenJobFinished",
                    expected: "(boolean | undefined)",
                    value: input.shutdownWhenJobFinished
                })) && (undefined === input.cacheSize || "number" === typeof input.cacheSize && !Number.isNaN(input.cacheSize) && (Math.floor(input.cacheSize) === input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-2147483648 <= input.cacheSize && input.cacheSize <= 2147483647 || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@type int)",
                    value: input.cacheSize
                })) && (-1 <= input.cacheSize || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "number (@minimum -1)",
                    value: input.cacheSize
                })) || $guard(_exceptionable, {
                    path: _path + ".cacheSize",
                    expected: "(number | undefined)",
                    value: input.cacheSize
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && (0 <= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@minimum 0)",
                    value: input.corruptionThreshold
                })) && (1 >= input.corruptionThreshold || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "number (@maximum 1)",
                    value: input.corruptionThreshold
                })) || $guard(_exceptionable, {
                    path: _path + ".corruptionThreshold",
                    expected: "(number | undefined)",
                    value: input.corruptionThreshold
                });
                const $ao2 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify || $guard(_exceptionable, {
                    path: _path + ".bypassVerify",
                    expected: "(boolean | undefined)",
                    value: input.bypassVerify
                })) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate || $guard(_exceptionable, {
                    path: _path + ".enableDatapoolUpdate",
                    expected: "(boolean | undefined)",
                    value: input.enableDatapoolUpdate
                })) && (undefined === input.processAll || "boolean" === typeof input.processAll || $guard(_exceptionable, {
                    path: _path + ".processAll",
                    expected: "(boolean | undefined)",
                    value: input.processAll
                })) && (undefined === input.inputExpiration || ("object" === typeof input.inputExpiration && null !== input.inputExpiration || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                })) && $ao3(input.inputExpiration, _path + ".inputExpiration", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".inputExpiration",
                    expected: "(DockerWorkerConfigV3DatasourceInputExpiration | undefined)",
                    value: input.inputExpiration
                }));
                const $ao3 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.minDaysToExpiration && !Number.isNaN(input.minDaysToExpiration) && (0 <= input.minDaysToExpiration || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number (@minimum 0)",
                    value: input.minDaysToExpiration
                })) || $guard(_exceptionable, {
                    path: _path + ".minDaysToExpiration",
                    expected: "number",
                    value: input.minDaysToExpiration
                })) && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy || $guard(_exceptionable, {
                    path: _path + ".handlingStrategy",
                    expected: "(\"ABORT\" | \"SKIP\")",
                    value: input.handlingStrategy
                }));
                const $ao4 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload || $guard(_exceptionable, {
                    path: _path + ".enableUpload",
                    expected: "(boolean | undefined)",
                    value: input.enableUpload
                })) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || (Array.isArray(input.enableUploadForTasks) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                })) && input.enableUploadForTasks.every((elem: any, _index1: number) => "string" === typeof elem || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks[" + _index1 + "]",
                    expected: "string",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".enableUploadForTasks",
                    expected: "(Array<string> | null | undefined)",
                    value: input.enableUploadForTasks
                }));
                const $ao5 = (input: any, _path: string, _exceptionable: boolean = true): boolean => undefined === input.taskName || "string" === typeof input.taskName && ($is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "string (@pattern_DockerWorkerConfigV3DockerTraining_taskName)",
                    value: input.taskName
                })) || $guard(_exceptionable, {
                    path: _path + ".taskName",
                    expected: "(string | undefined)",
                    value: input.taskName
                });
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV4Docker",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DockerWorkerConfigV4Docker",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DockerWorkerConfigV4Docker): string => {
        const $io1 = (input: any): boolean => undefined === input.corruptionThreshold || "number" === typeof input.corruptionThreshold && 0 <= input.corruptionThreshold && 1 >= input.corruptionThreshold;
        const $io2 = (input: any): boolean => (undefined === input.bypassVerify || "boolean" === typeof input.bypassVerify) && (undefined === input.enableDatapoolUpdate || "boolean" === typeof input.enableDatapoolUpdate) && (undefined === input.processAll || "boolean" === typeof input.processAll) && (undefined === input.inputExpiration || "object" === typeof input.inputExpiration && null !== input.inputExpiration && $io3(input.inputExpiration));
        const $io3 = (input: any): boolean => "number" === typeof input.minDaysToExpiration && 0 <= input.minDaysToExpiration && ("SKIP" === input.handlingStrategy || "ABORT" === input.handlingStrategy);
        const $io4 = (input: any): boolean => (undefined === input.enableUpload || "boolean" === typeof input.enableUpload) && (null === input.enableUploadForTasks || undefined === input.enableUploadForTasks || Array.isArray(input.enableUploadForTasks) && input.enableUploadForTasks.every((elem: any) => "string" === typeof elem));
        const $io5 = (input: any): boolean => undefined === input.taskName || "string" === typeof input.taskName && $is_custom("pattern_DockerWorkerConfigV3DockerTraining_taskName", "string", "", input.taskName);
        const $string = (typia.createAssertStringify as any).string;
        const $tail = (typia.createAssertStringify as any).tail;
        const $throws = (typia.createAssertStringify as any).throws;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.checkpoint ? "" : `"checkpoint":${undefined !== input.checkpoint ? $string(input.checkpoint) : undefined},`}${undefined === input.checkpointRunId ? "" : `"checkpointRunId":${undefined !== input.checkpointRunId ? $string(input.checkpointRunId) : undefined},`}${undefined === input.corruptnessCheck ? "" : `"corruptnessCheck":${undefined !== input.corruptnessCheck ? $so1(input.corruptnessCheck) : undefined},`}${undefined === input.datasource ? "" : `"datasource":${undefined !== input.datasource ? $so2(input.datasource) : undefined},`}${undefined === input.crops ? "" : `"crops":${undefined !== input.crops ? $so4(input.crops) : undefined},`}${undefined === input.embeddings ? "" : `"embeddings":${undefined !== input.embeddings ? $string(input.embeddings) : undefined},`}${undefined === input.enableTraining ? "" : `"enableTraining":${undefined !== input.enableTraining ? input.enableTraining : undefined},`}${undefined === input.training ? "" : `"training":${undefined !== input.training ? $so5(input.training) : undefined},`}${undefined === input.normalizeEmbeddings ? "" : `"normalizeEmbeddings":${undefined !== input.normalizeEmbeddings ? input.normalizeEmbeddings : undefined},`}${undefined === input.numProcesses ? "" : `"numProcesses":${undefined !== input.numProcesses ? input.numProcesses : undefined},`}${undefined === input.numThreads ? "" : `"numThreads":${undefined !== input.numThreads ? input.numThreads : undefined},`}${undefined === input.outputImageFormat ? "" : `"outputImageFormat":${undefined !== input.outputImageFormat ? $string(input.outputImageFormat) : undefined},`}${undefined === input.pretagging ? "" : `"pretagging":${undefined !== input.pretagging ? input.pretagging : undefined},`}${undefined === input.pretaggingUpload ? "" : `"pretaggingUpload":${undefined !== input.pretaggingUpload ? input.pretaggingUpload : undefined},`}${undefined === input.relevantFilenamesFile ? "" : `"relevantFilenamesFile":${undefined !== input.relevantFilenamesFile ? $string(input.relevantFilenamesFile) : undefined},`}${undefined === input.selectedSequenceLength ? "" : `"selectedSequenceLength":${undefined !== input.selectedSequenceLength ? input.selectedSequenceLength : undefined},`}${undefined === input.uploadReport ? "" : `"uploadReport":${undefined !== input.uploadReport ? input.uploadReport : undefined},`}${undefined === input.useDatapool ? "" : `"useDatapool":${undefined !== input.useDatapool ? input.useDatapool : undefined},`}${undefined === input.shutdownWhenJobFinished ? "" : `"shutdownWhenJobFinished":${undefined !== input.shutdownWhenJobFinished ? input.shutdownWhenJobFinished : undefined},`}${undefined === input.cacheSize ? "" : `"cacheSize":${undefined !== input.cacheSize ? input.cacheSize : undefined}`}`)}}`;
        const $so1 = (input: any): any => `{${$tail(`${undefined === input.corruptionThreshold ? "" : `"corruptionThreshold":${undefined !== input.corruptionThreshold ? input.corruptionThreshold : undefined}`}`)}}`;
        const $so2 = (input: any): any => `{${$tail(`${undefined === input.bypassVerify ? "" : `"bypassVerify":${undefined !== input.bypassVerify ? input.bypassVerify : undefined},`}${undefined === input.enableDatapoolUpdate ? "" : `"enableDatapoolUpdate":${undefined !== input.enableDatapoolUpdate ? input.enableDatapoolUpdate : undefined},`}${undefined === input.processAll ? "" : `"processAll":${undefined !== input.processAll ? input.processAll : undefined},`}${undefined === input.inputExpiration ? "" : `"inputExpiration":${undefined !== input.inputExpiration ? $so3(input.inputExpiration) : undefined}`}`)}}`;
        const $so3 = (input: any): any => `{"minDaysToExpiration":${input.minDaysToExpiration},"handlingStrategy":${(() => {
            if ("string" === typeof input.handlingStrategy)
                return $string(input.handlingStrategy);
            if ("string" === typeof input.handlingStrategy)
                return "\"" + input.handlingStrategy + "\"";
            $throws({
                expected: "(\"ABORT\" | \"SKIP\")",
                value: input.handlingStrategy
            });
        })()}}`;
        const $so4 = (input: any): any => `{${$tail(`${undefined === input.enableUpload ? "" : `"enableUpload":${undefined !== input.enableUpload ? input.enableUpload : undefined},`}${undefined === input.enableUploadForTasks ? "" : `"enableUploadForTasks":${undefined !== input.enableUploadForTasks ? null !== input.enableUploadForTasks ? `[${input.enableUploadForTasks.map((elem: any) => $string(elem)).join(",")}]` : "null" : undefined}`}`)}}`;
        const $so5 = (input: any): any => `{${$tail(`${undefined === input.taskName ? "" : `"taskName":${undefined !== input.taskName ? $string(input.taskName) : undefined}`}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DockerWorkerConfigV4DockerValidatorShape = {
    'checkpoint': yup.string(),
    'checkpointRunId': yup.string().matches(/^[a-f0-9]{24}$/),
    'corruptnessCheck': DockerWorkerConfigV3DockerCorruptnessCheckValidator.optional().default(undefined),
    'datasource': DockerWorkerConfigV3DockerDatasourceValidator.optional().default(undefined),
    'crops': DockerWorkerConfigV4DockerCropsValidator.optional().default(undefined),
    'embeddings': yup.string(),
    'enableTraining': yup.boolean(),
    'training': DockerWorkerConfigV3DockerTrainingValidator.optional().default(undefined),
    'normalizeEmbeddings': yup.boolean(),
    'numProcesses': yup.number().integer().min(-1),
    'numThreads': yup.number().integer().min(-1),
    'outputImageFormat': yup.string(),
    'pretagging': yup.boolean(),
    'pretaggingUpload': yup.boolean(),
    'relevantFilenamesFile': yup.string(),
    'selectedSequenceLength': yup.number().integer().min(1),
    'uploadReport': yup.boolean(),
    'useDatapool': yup.boolean(),
    'shutdownWhenJobFinished': yup.boolean(),
    'cacheSize': yup.number().integer().min(-1),
};
export const DockerWorkerConfigV4DockerValidator = yup.object().shape(DockerWorkerConfigV4DockerValidatorShape);
export const DockerWorkerConfigV4DockerStringifyShapeProperties: ObjectSchema['properties'] = {
    'checkpoint': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'checkpointRunId': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
    'corruptnessCheck': DockerWorkerConfigV3DockerCorruptnessCheckStringifyShape,
    'datasource': DockerWorkerConfigV3DockerDatasourceStringifyShape,
    'crops': DockerWorkerConfigV4DockerCropsStringifyShape,
    'embeddings': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'enableTraining': {
        'type': 'boolean',
    },
    'training': DockerWorkerConfigV3DockerTrainingStringifyShape,
    'normalizeEmbeddings': {
        'type': 'boolean',
    },
    'numProcesses': {
        'type': 'integer',
        'minimum': -1,
    } as unknown as fastJSON.IntegerSchema,
    'numThreads': {
        'type': 'integer',
        'minimum': -1,
    } as unknown as fastJSON.IntegerSchema,
    'outputImageFormat': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'pretagging': {
        'type': 'boolean',
    },
    'pretaggingUpload': {
        'type': 'boolean',
    },
    'relevantFilenamesFile': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'selectedSequenceLength': {
        'type': 'integer',
        'minimum': 1,
    } as unknown as fastJSON.IntegerSchema,
    'uploadReport': {
        'type': 'boolean',
    },
    'useDatapool': {
        'type': 'boolean',
    },
    'shutdownWhenJobFinished': {
        'type': 'boolean',
    },
    'cacheSize': {
        'type': 'integer',
        'minimum': -1,
    } as unknown as fastJSON.IntegerSchema,
};
export const DockerWorkerConfigV4DockerStringifyShape: ObjectSchema = {
    title: 'DockerWorkerConfigV4Docker Stringifier',
    type: 'object',
    properties: {
        ...DockerWorkerConfigV4DockerStringifyShapeProperties
    },
    required: [],
};
export const DockerWorkerConfigV4DockerStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerWorkerConfigV4DockerStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DockerWorkerConfigV4DockerStringify: (data: DockerWorkerConfigV4Docker) => string = DockerWorkerConfigV4DockerStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DockerWorkerConfigV4DockerFromJSON(json: any): DockerWorkerConfigV4Docker {
    return DockerWorkerConfigV4DockerFromJSONTyped(json, false);
}
export function DockerWorkerConfigV4DockerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerWorkerConfigV4Docker {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'checkpoint': !exists(json, 'checkpoint') ? undefined : json['checkpoint'],
        'checkpointRunId': !exists(json, 'checkpointRunId') ? undefined : json['checkpointRunId'],
        'corruptnessCheck': !exists(json, 'corruptnessCheck') ? undefined : DockerWorkerConfigV3DockerCorruptnessCheckFromJSON(json['corruptnessCheck']),
        'datasource': !exists(json, 'datasource') ? undefined : DockerWorkerConfigV3DockerDatasourceFromJSON(json['datasource']),
        'crops': !exists(json, 'crops') ? undefined : DockerWorkerConfigV4DockerCropsFromJSON(json['crops']),
        'embeddings': !exists(json, 'embeddings') ? undefined : json['embeddings'],
        'enableTraining': !exists(json, 'enableTraining') ? undefined : json['enableTraining'],
        'training': !exists(json, 'training') ? undefined : DockerWorkerConfigV3DockerTrainingFromJSON(json['training']),
        'normalizeEmbeddings': !exists(json, 'normalizeEmbeddings') ? undefined : json['normalizeEmbeddings'],
        'numProcesses': !exists(json, 'numProcesses') ? undefined : json['numProcesses'],
        'numThreads': !exists(json, 'numThreads') ? undefined : json['numThreads'],
        'outputImageFormat': !exists(json, 'outputImageFormat') ? undefined : json['outputImageFormat'],
        'pretagging': !exists(json, 'pretagging') ? undefined : json['pretagging'],
        'pretaggingUpload': !exists(json, 'pretaggingUpload') ? undefined : json['pretaggingUpload'],
        'relevantFilenamesFile': !exists(json, 'relevantFilenamesFile') ? undefined : json['relevantFilenamesFile'],
        'selectedSequenceLength': !exists(json, 'selectedSequenceLength') ? undefined : json['selectedSequenceLength'],
        'uploadReport': !exists(json, 'uploadReport') ? undefined : json['uploadReport'],
        'useDatapool': !exists(json, 'useDatapool') ? undefined : json['useDatapool'],
        'shutdownWhenJobFinished': !exists(json, 'shutdownWhenJobFinished') ? undefined : json['shutdownWhenJobFinished'],
        'cacheSize': !exists(json, 'cacheSize') ? undefined : json['cacheSize'],
    };
}
export function DockerWorkerConfigV4DockerToJSON(value?: DockerWorkerConfigV4Docker | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'checkpoint': value.checkpoint,
        'checkpointRunId': value.checkpointRunId,
        'corruptnessCheck': DockerWorkerConfigV3DockerCorruptnessCheckToJSON(value.corruptnessCheck),
        'datasource': DockerWorkerConfigV3DockerDatasourceToJSON(value.datasource),
        'crops': DockerWorkerConfigV4DockerCropsToJSON(value.crops),
        'embeddings': value.embeddings,
        'enableTraining': value.enableTraining,
        'training': DockerWorkerConfigV3DockerTrainingToJSON(value.training),
        'normalizeEmbeddings': value.normalizeEmbeddings,
        'numProcesses': value.numProcesses,
        'numThreads': value.numThreads,
        'outputImageFormat': value.outputImageFormat,
        'pretagging': value.pretagging,
        'pretaggingUpload': value.pretaggingUpload,
        'relevantFilenamesFile': value.relevantFilenamesFile,
        'selectedSequenceLength': value.selectedSequenceLength,
        'uploadReport': value.uploadReport,
        'useDatapool': value.useDatapool,
        'shutdownWhenJobFinished': value.shutdownWhenJobFinished,
        'cacheSize': value.cacheSize,
    };
}
